import { A } from "@solidjs/router";

export default () => {
	return (
		<>
			<h1 class="col-span-full text-center font-bold text-2xl">Welcome to RIAS-Regs</h1>
			<div class="rias-content col-span-full md:col-span-9">
				<p>
					RIAS-regs provides a number of schemes, each one of which is operated under
					license from the Building Standards Division of the Scottish Government. These
					are:
				</p>
				<ol>
					<li>
						Scheme Provider for the Certification of Section 6 &#8211; Energy (Domestic)
					</li>
					<li>
						Scheme Provider for the Certification of Section 6 &#8211; Energy
						(Non-domestic)
					</li>
				</ol>
				<p>
					Each Scheme has a separate and distinct legal status, however, as far as
					possible, we have streamlined the process by which an applicant can become a
					member of each.
				</p>
	
				<h2>Certification of Design</h2>
				<p>
					The Building (Scotland) Act 2003 provides the opportunity for design
					professionals in the construction industry practising in Scotland to be able to
					certify that a design meets one or more Sections of the Technical Standards.
				</p>
				<p>
					Certification of Design is applicable to all warrant applications to convert,
					alter, extend or build new buildings.
				</p>
				<p>
					To do so, a designer must demonstrate and maintain competency in that Section of
					the Technical Standards by becoming an Approved Certifier of Design recognised
					by a Scheme Provider approved by Scottish Ministers.
				</p>

				<h2>The Benefits of Design Certification</h2>
				<ol>
					<li>It distinguishes the design professional from those less qualified</li>
					<li>
						The Scottish Government is keen to see the Certification of Design become
						the norm for warrant applications. It already is for all, but the most minor
						of structural alterations.
					</li>
					<li>
						The Scottish Government’s public procurement guidance supports the use of
						Approved Certifiers of Design, making this the benchmark of competency for
						public projects
					</li>
					<li>
						As the pressure mounts on local authorities to process warrant applications
						those certified should be processed quicker with fewer points raised in
						warrant reports
					</li>
					<li>
						Applications for a building warrant, supported by a valid Certificate of
						Design will be eligible for at least a 10% discount for each section
						certified with the warrant application
					</li>
					<li>
						RIAS-Regs works closely with the Building Standards Division (BSD) of the
						Scottish Government, Local Authority Building Standards Scotland (LABSS),
						the Scottish Building Standards Hub and the other providers of design and
						construction certification Schemes. This enables us to advise Approved
						Certifiers of Design about the requirements of, procedures and changes to
						the Technical Standards as they develop.
					</li>
				</ol>
				<h2>CPD Membership</h2>
				<p>
					Building Control Officers working for one of the 32 Scottish Local Authorities
					can join the Scheme at zero cost. RIAS-regs also provides a low cost,
					non-certifier CPD Membership giving access basis in order to take advantage of
					free access to the Learning Materials and Practical SAP online competency tests
					(see FAQ’s). We are keen for feedback from all applicants as it helps us improve
					the competency tests and strengthens a shared understanding of the requirements
					of the Technical StandardsCompletion of the tests is considered to be the
					equivalent of 12 hours CPD and counts towards your application to become an
					Approved Certifier of Design (subject to meeting all other criteria).
				</p>
				<p>
					Simply follow the <A href="/registration">registration process</A> and tick the
					CPD button on the registration page.
				</p>
			</div>
			<div class="col-span-full md:col-span-3">
				<div id="membership-logos" class="flex flex-col items-center justify-between">
					<h3 class="font-bold">
						Schemes on this website are open to those architects registered with:
					</h3>
					<A href="http://arb.org.uk/" target="_blank" rel="noopener noreferrer">
						<img
							decoding="async"
							class="w-auto h-25"
							src="/images/arb.svg"
							alt="Architects Registration Board"
						/>
					</A>
					<h4 class="font-bold my-5">and those practising members of:</h4>
					<A href="https://www.rias.org.uk/" target="_blank" rel="noopener noreferrer">
						<img
							decoding="async"
							class="w-auto h-37.5"
							src="/images/rias.svg"
							alt="The Royal Incorporation of Architects in Scotland"
						/>
					</A>
					<A
						href="https://www.architecture.com/"
						target="_blank"
						rel="noopener noreferrer">
						<img
							decoding="async"
							class="w-auto h-25"
							src="/images/riba.svg"
							alt="The Royal Institute of British Architects"
						/>
					</A>
					<A href="https://ciat.org.uk/" target="_blank" rel="noopener noreferrer">
						<img
							decoding="async"
							class="w-auto h-25"
							src="/images/ciat.png"
							alt="The Chartered Institute of Architectural Technologists"
						/>
					</A>
					<A href="https://www.cibse.org/" target="_blank" rel="noopener noreferrer">
						<img
							decoding="async"
							class="w-auto h-37.5"
							src="/images/cibse.png"
							alt="The Chartered Institution of Building Services Engineers"
						/>
					</A>
				</div>
			</div>
		</>
	);
};
